
import React, { useState } from 'react';
import logo from '../../assets/images/logo3.png';
import animatedLogo from '../../assets/images/animation.gif'; // Replace with your GIF path
import styles from '../styles/Navbar.module.css';
import Button from '../Button';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';

const ParentApplicationNavbar = ({ step = 0, totalSteps = 10 }) => {
  let navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const progress = ((step + 1) / totalSteps) * 100;

  return (
    <header
      className={styles.header}
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        background: 'white',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: 0,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', padding: '10px 20px' }}>
        <a href="/">
          <img
            className={styles.logo}
            src={isHovered ? animatedLogo : logo}
            alt="Logo"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          />
        </a>
        <h4 style={{ margin: 0, fontWeight: 'bold', flex: 1, textAlign: 'center' }}>
          Dual School Admission Application
        </h4>
        <nav className={styles.nav}></nav>
      </div>
      {/* Progress Bar Divider at the bottom of the header */}
      <div
        style={{
          width: '100%',
          height: 4,
          background: '#e0e0e0',
        }}
      >
        <div
          style={{
            width: `${progress}%`,
            height: '100%',
            background: 'black',
            transition: 'width 0.3s',
          }}
        />
      </div>
    </header>
  );
};

export default ParentApplicationNavbar;
